module.exports = __webpack_public_path__ + "img/logo.b83cba53.png";